import React from 'react';
import style from './style.module.css'

interface PartItemProps {
    active: boolean;
    label: string;
    click?: any;
}

const PartItem: React.FC<PartItemProps> = ({active,label,click = () => {}}) => {

    const handleClick = () => {
        click()
    }

    return (<>
        <div className={`${style.partItem} ${active ? style.active : ''}`} onClick={handleClick}>
            {label}
        </div>
    </>)
}

export default PartItem;